import { render, staticRenderFns } from "./customer_service.vue?vue&type=template&id=4a0ebf77&scoped=true&"
import script from "./customer_service.vue?vue&type=script&lang=js&"
export * from "./customer_service.vue?vue&type=script&lang=js&"
import style0 from "./customer_service.vue?vue&type=style&index=0&id=4a0ebf77&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0ebf77",
  null
  
)

export default component.exports